import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(orderConfirmationBillingInformationStyles, {
    billingInformationGridContainer: {
        css: css`
            margin-bottom: 1rem;
            p,
            span {
                font-size: ${TYPOGRAPHY.size.smallest};
            }
            > ${GridOffset} {
                width: calc(100% + 10px) !important;
                margin-left: 0;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100% !important;
                                margin: 0;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    billingInformationTitle: {
        variant: "h4",
        as: "h4",
    },
    billingAddressTitle: {
        variant: "h4",
        as: "h4",
    },
    billingCreditCardAddressTitle: {
        variant: "h4",
        as: "h4",
    },

    billingInformationTitleGridItem: {
        width: 12,
        css: css`
            padding: 5px;
            background: ${COLORS.background.shade};
            border-bottom: 1px solid #3470b2;
            padding: 10px 5px;
            @media print {
                -webkit-print-color-adjust: exact;
            }
        `,
    },
    billingInformationBillingAddressGridItem: {
        width: [12, 12, 4, 4, 4],
        printWidth: 4,
        css: css`
            flex-direction: column;
            padding: 5px;
        `,
    },
    billingInformationCreditCardAddressGridItem: {
        width: [6, 6, 4, 4, 4],
        printWidth: 4,
        css: css`
            flex-direction: column;
            padding: 5px;
        `,
    },
});
